import React, { Component } from 'react';

class ModalIngresoAjustes extends Component {

    constructor(props) {
        super(props);
    }


    render() {

        return (
            <div className='modalContainer'>
                <div className="modalDemandaOutXS">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="close" data-dismiss="modal" aria-hidden="true">
                                <label onClick={() => this.props.openModalAjustesCargos(false, undefined, false, false)} className="ti-close clickable"></label>
                            </div>
                            <h2 className="modal-title">{this.props.titulo}</h2>
                        </div>
                        <div className="modal-body"><p>{this.props.mensaje}</p></div>
                        <div className='modalProcesosFooterShort'>
                            <button onClick={() =>  this.props.openModalAjustesCargos(false, undefined, false, false)} className="btn btn-secondary">Cancelar</button>
                            <button className="btn btn-cta" onClick={() => this.props.limpiarForm()}>Aceptar</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ModalIngresoAjustes;